// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangLayoutRouteImport } from './routes/$lang/_layout'
import { Route as LangLayoutIndexRouteImport } from './routes/$lang/_layout/index'
import { Route as LangLayoutHeartOrPassRouteImport } from './routes/$lang/_layout/heart-or-pass'
import { Route as LangLayoutBasketRouteImport } from './routes/$lang/_layout/basket'
import { Route as LangLayoutAboutRouteImport } from './routes/$lang/_layout/about'
import { Route as LangLayoutProductsIndexRouteImport } from './routes/$lang/_layout/products/index'
import { Route as LangLayoutCollectionsIndexRouteImport } from './routes/$lang/_layout/collections/index'
import { Route as LangLayoutProductsProductIdRouteImport } from './routes/$lang/_layout/products/$productId'
import { Route as LangLayoutCollectionsCollectionIdRouteImport } from './routes/$lang/_layout/collections/$collectionId'
import { Route as LangLayoutLegalTermsAndConditionsRouteImport } from './routes/$lang/_layout/_legal/terms-and-conditions'
import { Route as LangLayoutLegalPrivacyRouteImport } from './routes/$lang/_layout/_legal/privacy'
import { Route as LangLayoutLegalLegalRouteImport } from './routes/$lang/_layout/_legal/legal'

const LangRoute = LangRouteImport.update({
            id: '/$lang',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LangLayoutRoute = LangLayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => LangRoute
          })
const LangLayoutIndexRoute = LangLayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutHeartOrPassRoute = LangLayoutHeartOrPassRouteImport.update({
            id: '/heart-or-pass',path: '/heart-or-pass',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutBasketRoute = LangLayoutBasketRouteImport.update({
            id: '/basket',path: '/basket',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutAboutRoute = LangLayoutAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutProductsIndexRoute = LangLayoutProductsIndexRouteImport.update({
            id: '/products/',path: '/products/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCollectionsIndexRoute = LangLayoutCollectionsIndexRouteImport.update({
            id: '/collections/',path: '/collections/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutProductsProductIdRoute = LangLayoutProductsProductIdRouteImport.update({
            id: '/products/$productId',path: '/products/$productId',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCollectionsCollectionIdRoute = LangLayoutCollectionsCollectionIdRouteImport.update({
            id: '/collections/$collectionId',path: '/collections/$collectionId',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutLegalTermsAndConditionsRoute = LangLayoutLegalTermsAndConditionsRouteImport.update({
            id: '/_legal/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutLegalPrivacyRoute = LangLayoutLegalPrivacyRouteImport.update({
            id: '/_legal/privacy',path: '/privacy',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutLegalLegalRoute = LangLayoutLegalLegalRouteImport.update({
            id: '/_legal/legal',path: '/legal',getParentRoute: () => LangLayoutRoute
          })





const LangLayoutRouteChildren = {
  LangLayoutAboutRoute: LangLayoutAboutRoute,LangLayoutBasketRoute: LangLayoutBasketRoute,LangLayoutHeartOrPassRoute: LangLayoutHeartOrPassRoute,LangLayoutIndexRoute: LangLayoutIndexRoute,LangLayoutLegalLegalRoute: LangLayoutLegalLegalRoute,LangLayoutLegalPrivacyRoute: LangLayoutLegalPrivacyRoute,LangLayoutLegalTermsAndConditionsRoute: LangLayoutLegalTermsAndConditionsRoute,LangLayoutCollectionsCollectionIdRoute: LangLayoutCollectionsCollectionIdRoute,LangLayoutProductsProductIdRoute: LangLayoutProductsProductIdRoute,LangLayoutCollectionsIndexRoute: LangLayoutCollectionsIndexRoute,LangLayoutProductsIndexRoute: LangLayoutProductsIndexRoute
}

const LangLayoutRouteWithChildren = LangLayoutRoute._addFileChildren(LangLayoutRouteChildren)



const LangRouteChildren = {
  LangLayoutRoute: LangLayoutRouteWithChildren
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LangRoute: LangRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)